import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { Button } from 'antd';
import React from 'react';
import { BusinessUnitProvider } from '../context';
import { BusinessUnitTable } from './List/BusinessUnitTable';
import { DetailBusinessUnit } from './Form';
import { Authorize } from '@/core';
import { useUserPermissions } from '@/core/hooks';
import { PERMISSIONS } from '@/contants';

export const BusinessUnitScreen: React.FC<unknown> = () => {
  const { open, handleClose, setOpen, handleClickCreate } = useHandleActionItem();
  const { hasPermission } = useUserPermissions();

  return (
    <>
      <BusinessUnitProvider>
        <div className='bg-white py-4 px-4 flex flex-col flex-wrap'>
          <div className='ml-auto'>
            {hasPermission(PERMISSIONS.BUSINESS_UNITS.CREATE) && (
              <Button
                type='primary'
                size='middle'
                onClick={() => handleClickCreate()}
                className='rounded'
              >
                + Create
              </Button>
            )}
          </div>
          <div className='w-full mt-2'>
            <BusinessUnitTable />
            <DetailBusinessUnit open={open} handleClose={handleClose} setOpen={setOpen} />
          </div>
        </div>
      </BusinessUnitProvider>
    </>
  );
};

export const BusinessUnitList = Authorize<unknown>(
  BusinessUnitScreen,
  PERMISSIONS.BUSINESS_UNITS.VIEW,
);
